<script setup>
import ColorFilters from './ColorFilters.vue'
</script>
<template>
   <Card>
    <Heading bold> 
      <Row inline class="items-center"><Row locked :ProBadge="false">{{__('Adjust your automatic color filter', 'wp-dark-mode')}}</Row> <ProBadge /></Row>
      <Hints locked>{{__('Adjust the your automatic color for dark mode color scheme', 'wp-dark-mode')}}</Hints>
   </Heading>
    <div class="h-0.5 w-full bg-gray-100 my-3"></div>
    <ColorFilters /> 
   </Card>
</template>